import { useGetIntegratedPartnerIds } from '.';

export default function useGetIntegratedPartnerId(): string | null {
  const { legalInsurancePartnerId, partnerId } = useGetIntegratedPartnerIds();

  if (legalInsurancePartnerId) {
    return legalInsurancePartnerId;
  }

  if (partnerId) {
    return partnerId;
  }

  return null;
}
